// One namespace per feature area, so parallel work on two modules never edits
// the same file. Norwegian is the source of truth for the key set (see the
// CustomTypeOptions in ./i18next.d.ts); locales.test.ts holds English to it.
import noCommon from '../locales/no/common.json'
import noNav from '../locales/no/nav.json'
import noAuth from '../locales/no/auth.json'
import noAccount from '../locales/no/account.json'
import noComponents from '../locales/no/components.json'
import noDashboard from '../locales/no/dashboard.json'
import noErrors from '../locales/no/errors.json'
import noAnalytics from '../locales/no/analytics.json'
import noAge from '../locales/no/age.json'
import noLeasingLoans from '../locales/no/leasingLoans.json'
import noOrganizations from '../locales/no/organizations.json'
import noHendelser from '../locales/no/hendelser.json'
import noOppslag from '../locales/no/oppslag.json'
import noBruktbil from '../locales/no/bruktbil.json'
import noStaatid from '../locales/no/staatid.json'
import noBbf from '../locales/no/bbf.json'
import noLeads from '../locales/no/leads.json'
import noKampanjer from '../locales/no/kampanjer.json'
import noTeknisk from '../locales/no/teknisk.json'
import noAndreKjoretoy from '../locales/no/andreKjoretoy.json'

import enCommon from '../locales/en/common.json'
import enNav from '../locales/en/nav.json'
import enAuth from '../locales/en/auth.json'
import enAccount from '../locales/en/account.json'
import enComponents from '../locales/en/components.json'
import enDashboard from '../locales/en/dashboard.json'
import enErrors from '../locales/en/errors.json'
import enAnalytics from '../locales/en/analytics.json'
import enAge from '../locales/en/age.json'
import enLeasingLoans from '../locales/en/leasingLoans.json'
import enOrganizations from '../locales/en/organizations.json'
import enHendelser from '../locales/en/hendelser.json'
import enOppslag from '../locales/en/oppslag.json'
import enBruktbil from '../locales/en/bruktbil.json'
import enStaatid from '../locales/en/staatid.json'
import enBbf from '../locales/en/bbf.json'
import enLeads from '../locales/en/leads.json'
import enKampanjer from '../locales/en/kampanjer.json'
import enTeknisk from '../locales/en/teknisk.json'
import enAndreKjoretoy from '../locales/en/andreKjoretoy.json'

export const resources = {
  no: {
    common: noCommon,
    nav: noNav,
    auth: noAuth,
    account: noAccount,
    components: noComponents,
    dashboard: noDashboard,
    errors: noErrors,
    analytics: noAnalytics,
    age: noAge,
    leasingLoans: noLeasingLoans,
    organizations: noOrganizations,
    hendelser: noHendelser,
    oppslag: noOppslag,
    bruktbil: noBruktbil,
    staatid: noStaatid,
    bbf: noBbf,
    leads: noLeads,
    kampanjer: noKampanjer,
    teknisk: noTeknisk,
    andreKjoretoy: noAndreKjoretoy,
  },
  en: {
    common: enCommon,
    nav: enNav,
    auth: enAuth,
    account: enAccount,
    components: enComponents,
    dashboard: enDashboard,
    errors: enErrors,
    analytics: enAnalytics,
    age: enAge,
    leasingLoans: enLeasingLoans,
    organizations: enOrganizations,
    hendelser: enHendelser,
    oppslag: enOppslag,
    bruktbil: enBruktbil,
    staatid: enStaatid,
    bbf: enBbf,
    leads: enLeads,
    kampanjer: enKampanjer,
    teknisk: enTeknisk,
    andreKjoretoy: enAndreKjoretoy,
  },
} as const
